/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker } from 'components/filters';
import {} from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
/* eslint-enable */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function AlcoholLicenseFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.restaurantNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.name === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.address === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.zipCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.city === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.organizationNumber === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.permitHolder === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.categoryCode === 'undefined' && (
          <FormGroup>
            <Label>Typ av serveringstillstånd</Label>
            <Select
              type="string"
              instanceId="select-categoryCode"
              name="categoryCode"
              value={_.get(resolvedQuery, 'categoryCode')}
              onChange={handleChange}
              options={[
                {
                  label:
                    'Servering till allmänheten - Servering - året runt - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '21',
                },
                {
                  label:
                    'Servering till allmänheten - Servering - årligen under viss tidsperiod - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '22',
                },
                {
                  label:
                    'Servering till allmänheten - Servering - året runt - Vin och andra jästa alkoholdrycker, starköl',
                  value: '41',
                },
                {
                  label:
                    'Servering till allmänheten - Servering - årligen under viss tidsperiod - Vin och andra jästa alkoholdrycker, starköl',
                  value: '42',
                },
                {
                  label:
                    'Servering till allmänheten - Servering - året runt - Starköl',
                  value: '61',
                },
                {
                  label:
                    'Servering till allmänheten - Servering - årligen under viss tidsperiod - Starköl',
                  value: '62',
                },
                {
                  label:
                    'Servering till allmänheten - Trafikservering - året runt - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '27',
                },
                {
                  label:
                    'Servering till allmänheten - Trafikservering - året runt - Vin och andra jästa alkoholdrycker, starköl',
                  value: '47',
                },
                {
                  label:
                    'Servering till allmänheten - Trafikservering - året runt - Starköl',
                  value: '67',
                },
                {
                  label:
                    'Servering till allmänheten - Pausservering - året runt - Vin och andra jästa alkoholdrycker, starköl',
                  value: '48',
                },
                {
                  label:
                    'Servering till allmänheten - Pausservering - året runt - Starköl',
                  value: '68',
                },
                {
                  label:
                    'Servering till allmänheten - Provsmakning - året runt - Egen tillverkad alkoholdryck',
                  value: '91',
                },
                {
                  label:
                    'Servering till allmänheten - Provsmakning - årligen under viss tidsperiod - Egen tillverkad alkoholdryck',
                  value: '92',
                },
                {
                  label:
                    'Servering till slutna sällskap - Servering - året runt - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '24',
                },
                {
                  label:
                    'Servering till slutna sällskap - Servering - årligen under viss tidsperiod - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '25',
                },
                {
                  label:
                    'Servering till slutna sällskap - Servering - året runt - Vin och andra jästa alkoholdrycker, starköl',
                  value: '44',
                },
                {
                  label:
                    'Servering till slutna sällskap - Servering - årligen under viss tidsperiod - Vin och andra jästa alkoholdrycker, starköl',
                  value: '45',
                },
                {
                  label:
                    'Servering till slutna sällskap - Servering - året runt - Starköl',
                  value: '64',
                },
                {
                  label:
                    'Servering till slutna sällskap - Servering - årligen under viss tidsperiod - Starköl',
                  value: '65',
                },
                {
                  label:
                    'Servering till slutna sällskap - Catering - året runt - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '74',
                },
                {
                  label:
                    'Servering till slutna sällskap - Catering - årligen under viss tidsperiod - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '75',
                },
                {
                  label:
                    'Servering till slutna sällskap - Catering - året runt - Vin och andra jästa alkoholdrycker, starköl',
                  value: '84',
                },
                {
                  label:
                    'Servering till slutna sällskap - Catering - årligen under viss tidsperiod - Vin och andra jästa alkoholdrycker, starköl',
                  value: '85',
                },
                {
                  label:
                    'Servering till slutna sällskap - Catering - året runt - Starköl',
                  value: '94',
                },
                {
                  label:
                    'Servering till slutna sällskap - Catering - årligen under viss tidsperiod - Starköl',
                  value: '95',
                },
                {
                  label:
                    'Servering till slutna sällskap - Trafikservering - året runt - Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '26',
                },
                {
                  label:
                    'Servering till slutna sällskap - Trafikservering - året runt - Vin och andra jästa alkoholdrycker, starköl',
                  value: '46',
                },
                {
                  label:
                    'Servering till slutna sällskap - Trafikservering - året runt - Starköl',
                  value: '66',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering - året runt - Till allmänheten: Vin och andra jästa alkoholdrycker, starköl. Till slutet sällskap: Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '97',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering - årligen under viss tidsperiod - Till allmänheten: Starköl. Till slutet sällskap: Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '98',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Övriga kombinerade tillstånd - året runt',
                  value: '99',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Starköl. Till slutet sällskap: Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '1',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Till allmänheten: Spritdryck, vin och andra jästa alkoholdrycker, starköl. Till slutet sällskap: Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '2',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Spritdryck, vin och andra jästa alkoholdrycker, starköl. Till slutet sällskap: Vin och andra jästa alkoholdrycker, starköl',
                  value: '3',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Till allmänheten: Spritdryck, vin och andra jästa alkoholdrycker, starköl. Till slutet sällskap: Vin och andra jästa alkoholdrycker, starköl',
                  value: '4',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Spritdryck, vin och andra jästa alkoholdrycker, starköl. Till slutet sällskap: Starköl',
                  value: '5',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Till allmänheten: Spritdryck, vin och andra jästa alkoholdrycker, starköl. Till slutet sällskap: Starköl',
                  value: '6',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Vin och andra jästa alkoholdrycker, starköl, starköl. Till slutet sällskap: Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '7',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Till allmänheten: Vin och andra jästa alkoholdrycker, starköl, starköl. Till slutet sällskap: Vin och andra jästa alkoholdrycker, starköl',
                  value: '8',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Vin och andra jästa alkoholdrycker, starköl, starköl. Till slutet sällskap: Vin och andra jästa alkoholdrycker, starköl',
                  value: '9',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Till allmänheten: Vin och andra jästa alkoholdrycker, starköl, starköl. Till slutet sällskap: Vin och andra jästa alkoholdrycker, starköl',
                  value: '10',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Vin och andra jästa alkoholdrycker, starköl, starköl. Till slutet sällskap: Starköl',
                  value: '13',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Till allmänheten: Vin och andra jästa alkoholdrycker, starköl, starköl. Till slutet sällskap: Starköl',
                  value: '14',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Spritdryck, Till allmänheten: Starköl. Till slutet sällskap: Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '15',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Spritdryck, Till allmänheten: Starköl. Till slutet sällskap: Spritdryck, vin och andra jästa alkoholdrycker, starköl',
                  value: '16',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Starköl. Till slutet sällskap: Vin och andra jästa alkoholdrycker, starköl',
                  value: '17',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - årligen under viss tidsperiod - Till allmänheten: Starköl. Till slutet sällskap: Vin och andra jästa alkoholdrycker, starköl',
                  value: '18',
                },
                {
                  label:
                    'Servering till allmänheten och slutna sällskap - Servering till allmänheten och catering - året runt - Till allmänheten: Starköl. Till slutet sällskap: Starköl',
                  value: '19',
                },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.county === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.validFrom === 'undefined' && (
          <FormGroup>
            <Label>Giltig fr.o.m</Label>
            <DateRangePicker
              name="validFrom"
              value={_.get(resolvedQuery, 'validFrom')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.validTrial === 'undefined' && (
          <FormGroup>
            <Label>Giltig, prövotid</Label>
            <DateRangePicker
              name="validTrial"
              value={_.get(resolvedQuery, 'validTrial')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.validUntil === 'undefined' && (
          <FormGroup>
            <Label>Giltig t.o.m.</Label>
            <DateRangePicker
              name="validUntil"
              value={_.get(resolvedQuery, 'validUntil')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.active === 'undefined' && (
          <FormGroup>
            <Label>Serveringstillstånd</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'active') === undefined}
                onClick={() => {
                  handleChange('active', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === true ||
                  _.get(resolvedQuery, 'active') === 'true'
                }
                onClick={() => {
                  handleChange('active', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === false ||
                  _.get(resolvedQuery, 'active') === 'false'
                }
                onClick={() => {
                  handleChange('active', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isQvantiCustomer === 'undefined' && (
          <FormGroup>
            <Label>Qvanti kund</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'isQvantiCustomer') === undefined}
                onClick={() => {
                  handleChange('isQvantiCustomer', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isQvantiCustomer') === true ||
                  _.get(resolvedQuery, 'isQvantiCustomer') === 'true'
                }
                onClick={() => {
                  handleChange('isQvantiCustomer', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isQvantiCustomer') === false ||
                  _.get(resolvedQuery, 'isQvantiCustomer') === 'false'
                }
                onClick={() => {
                  handleChange('isQvantiCustomer', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

AlcoholLicenseFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

AlcoholLicenseFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function AlcoholLicenseFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <AlcoholLicenseFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

AlcoholLicenseFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

AlcoholLicenseFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { AlcoholLicenseFilterPanel, AlcoholLicenseFilterPanelModal };
